// extracted by css-extract-rspack-plugin
export default {"sub-tabs":"yqhQT0","subTabs":"yqhQT0"};